// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @19.06.2017 15:21:15
import { ListCrisisDashboardMessage_abstract } from './../../abstract/SagaSchema/ListObjects/ListCrisisDashboardMessage_abstract';
export class ListCrisisDashboardMessage extends ListCrisisDashboardMessage_abstract {}
